import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setError } from '../actions';
import { FORM_VALUES } from '../utils/helpers/constants';
import { getCategories } from '../api/queries';
import { CategoriesQuery } from '../graphql/graphql';
import { ItemCreationFormValuesType } from '../utils/helpers/convertFormToQueryInput';

type DataType = string | number | null | boolean | object | undefined;

export const useCategoriesData = ({
  categoryId,
  typeEstate,
  change
}: {
  categoryId: DataType;
  typeEstate: DataType;
  change: <F extends keyof ItemCreationFormValuesType>(
    name: F,
    value?: ItemCreationFormValuesType[F] | undefined
  ) => void;
}) => {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery<CategoriesQuery>(getCategories);
  const categoriesData = loading || !data ? [] : data.categories;

  const initialCategoryObj = categoriesData.find(
    item => item.id === categoryId
  );

  useEffect(() => {
    if (!typeEstate) {
      change(FORM_VALUES.typeEstate, initialCategoryObj?.name);
    }
    if (!categoryId) {
      change(FORM_VALUES.categoryId, initialCategoryObj?.id);
    }
  }, [categoriesData.length, typeEstate, categoryId, change]);

  useEffect(() => {
    if (error) dispatch(setError(true));
  }, [error]);
};
